


































import { Component, Prop, Vue } from 'vue-property-decorator';
import Warning from '@/components/page/Warning.vue';
import { ModelLibService } from '@/api/com/MetaPattern/APP/MDA/ModelLib/ModelLibService';
import { UnitInfoDTO } from '@/api/com/MetaPattern/APP/MDA/ModelLib/UnitInfoDTO';
import UseAPP from '@/components/page/UseAPP.vue';

@Component({
  components: {
    Warning,
    UseAPP
  }
})
export default class ModelLib extends Vue {
  private units: Array<UnitInfoDTO>;
  private showUseAPP: boolean;
  private key = 0;
  private curUnit: UnitInfoDTO;

  constructor() {
    super();
    this.showUseAPP = false;
    this.curUnit = null;
    this.units = null;
  }

  get unitData() {
    if (this.units === null) {
      ModelLibService.GetUnitPageAsync(1, 20).then(res => {
        console.log(res);
        this.units = res;
      });
    }
    return this.units;
  }

  getPrice(price: number) {
    if (price === 0) {
      return '免费';
    }
    return `￥${price}`;
  }

  getIsFree(price: number) {
    return price === 0;
  }

  useAPP(unit: UnitInfoDTO) {
    this.key++;
    this.showUseAPP = true;
    this.curUnit = unit;
  }

  closeUseAPP() {
    this.showUseAPP = false;
  }
}

